import { useLocation, useNavigate } from 'react-router'
import { AuthShell } from '@/components/AuthShell'
import { LoadingState } from '@/components/PageState'
import { Button } from '@/components/ui/button'

/** The whole-page spinner for PixelSign's pay and card pages. */
export function HandoffLoading() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-canvas">
      <LoadingState />
    </div>
  )
}

/** Asks the person to sign in to their organization, then brings them back here. */
export function HandoffSignIn({ title }: { title: string }) {
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <AuthShell title={title} description="Sign in to your organization on PixelSign to continue." size="md">
      <Button onClick={() => void navigate('/login', { state: { from: `${location.pathname}${location.search}` } })}>
        Sign in
      </Button>
    </AuthShell>
  )
}
